module.exports = __webpack_public_path__ + "img/floorplan-firstfinancial.20282404.png";